import { floatToLocaleString } from '#imports';
import { usePropertyContext } from '~/composables/usePropertyContext';

export function usePropertyValues() {
	const { property } = usePropertyContext();

	const formatCurrency = (value: number | null | undefined): string | null => {
		if (!value || value <= 0) return null;

		return floatToLocaleString(value, {
			style: 'currency',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
			roundingMode: 'ceil'
		});
	};

	const formattedPrice = computed<string | null>(() =>
		formatCurrency(property.value?.askingPrice)
	);

	const formattedCondoFee = computed<string | null>(() =>
		formatCurrency(property.value?.condoFee)
	);

	const formattedTax = computed<string | null>(() =>
		formatCurrency(property.value?.tax)
	);

	return {
		formattedPrice,
		formattedCondoFee,
		formattedTax
	};
}
